<template>
  <div class="col-12">
    <LineChart :height="height" :chartData="testData" :options="options" />
  </div>
</template>

<script>
import { computed, ref } from "vue";
import { LineChart } from "vue-chart-3";
import { Chart, registerables } from "chart.js";

Chart.register(...registerables);

export default {
  components: { LineChart },
  props: {
    labels: { type: Array },
    datasets: { type: Array },
    height: { type: Number, default: 650 },
    formatType: { type: String, default: "currency" },
  },
  setup(props) {
    const formatarPreco = (valor) => {
      if (valor == null || valor === undefined) return "R$ 0,00";
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(parseFloat(valor));
    };

    const formatarInteiro = (valor) => {
      if (valor == null || valor === undefined) return "0";
      return Math.floor(parseFloat(valor)).toLocaleString("pt-BR");
    };

    const testData = computed(() => ({
      labels: props.labels,
      datasets: props.datasets,
    }));

    const options = ref({
      responsive: true,
      plugins: {
        legend: {
          display: false,
        },
        title: {
          display: false,
        },
        datalabels: {
          display: true, // SEMPRE mostra os valores
          color: "#213864",
          font: {
            weight: "bold",
            size: 9, // menor fonte para caber mais
          },
          anchor: "end",
          align: "top",
          offset: 2,
          clamp: true, // impede que labels saiam fora do canvas
          formatter: (value) => {
            if (props.formatType === "currency") {
              return formatarPreco(value);
            } else if (props.formatType === "integer") {
              return formatarInteiro(value);
            }
            return value;
          },
        },
        tooltip: {
          callbacks: {
            label: function (context) {
              const value = context.parsed.y;
              if (props.formatType === "currency") {
                return formatarPreco(value);
              } else if (props.formatType === "integer") {
                return formatarInteiro(value);
              }
              return value;
            },
          },
        },
      },
      scales: {
        x: {
          ticks: {
            autoSkip: false,
            maxRotation: 45,
            minRotation: 30,
            maxTicksLimit: 10,
            font: {
              size: 10,
            },
          },
        },
        y: {
          ticks: {
            callback: function (value) {
              if (props.formatType === "currency") {
                return formatarPreco(value);
              } else if (props.formatType === "integer") {
                return formatarInteiro(value);
              }
              return value;
            },
            font: {
              size: 10,
            },
          },
        },
      },
    });

    return { testData, options };
  },
};
</script>
